import script from "./canva_cta_variant_c.vue?vue&type=script&setup=true&lang=js"
export * from "./canva_cta_variant_c.vue?vue&type=script&setup=true&lang=js"

import "./canva_cta_variant_c.vue?vue&type=style&index=0&id=2780025f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2780025f"]])

export default __exports__